import React, { useCallback, useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ModalCTAButton from '../ModalCTAButton';
import FragmentsValue from '../../FragmentsValue';
import { getRecipientSectionName } from '../../utils';
import BadgeAwardDescription from '../descriptions/BadgeAwardDescription';
import BadgeCard from '../BadgeCard';
import NeedMoreFragments from '../NeedMoreFragments';
import s from './DesktopAwardBadgeModal.scss';
const DesktopAwardBadgeModal = ({ hasCore, coreLevel, recipient, typeId, itemId, balance, badges, isOpen, isAwarding, errorMsg, awardBadge, fetchAvailableBadges, requestClose })=>{
    const { t } = useTranslation();
    const [selectedIdx, setSelectedIdx] = useState(null);
    const [showError, setShowError] = useState(false);
    useEffect(()=>{
        fetchAvailableBadges(recipient.user.userId, typeId, itemId);
    }, [
        recipient,
        fetchAvailableBadges,
        typeId,
        itemId
    ]);
    useEffect(()=>{
        if (badges.length > 0) {
            setSelectedIdx(0);
        }
    }, [
        badges
    ]);
    useEffect(()=>{
        setShowError(errorMsg ? true : false);
    }, [
        errorMsg
    ]);
    const changeSelectedBadge = (idx)=>{
        setSelectedIdx(idx);
        setShowError(false);
    };
    const selectedBadge = selectedIdx !== null ? badges[selectedIdx] : undefined;
    const awardSelectedBadge = useCallback(()=>selectedBadge && awardBadge(selectedBadge.badge.name, recipient), [
        selectedBadge,
        awardBadge,
        recipient
    ]);
    const hasInsufficientFragmentsForSelectedBadge = selectedIdx !== null && badges[selectedIdx] && badges[selectedIdx].price > balance;
    if (badges.length === 0) {
        return /*#__PURE__*/ React.createElement(DSModal, {
            className: s['root-loading'],
            isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : false,
            onRequestClose: requestClose,
            heading: t('coreBadge.awardBadgeModal.heading'),
            showHeaderBorder: true
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['content-wrapper']
        }, /*#__PURE__*/ React.createElement(LoadingIndicator, null)));
    }
    const renderWhatAreBadgeAwards = ()=>/*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
            className: s['fragments-balance']
        }, /* prettier-ignore */ /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: "coreBadge.awardBadgeModal.balance",
            count: balance
        }, "You have ", /*#__PURE__*/ React.createElement(FragmentsValue, {
            amount: balance,
            className: s['fragments-value']
        }))), /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
            className: s['what-are-badge-awards'],
            target: "_blank",
            href: "https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments",
            biData: BiData({
                evid: 324,
                sectionname: 'give_badges',
                itemid: recipient.itemId,
                typeid: recipient.typeId
            })
        }, t('coreBadge.awardBadgeModal.linkToKB')));
    const renderPrimaryButton = ()=>{
        return /*#__PURE__*/ React.createElement(ModalCTAButton, {
            className: s['give-button'],
            mode: hasInsufficientFragmentsForSelectedBadge ? !hasCore ? 'link-to-core' : 'close-modal' : 'award-badge',
            selectedBadge: selectedBadge,
            recipient: recipient,
            disabled: isAwarding,
            awardSelectedBadge: awardSelectedBadge,
            requestClose: requestClose
        });
    };
    return /*#__PURE__*/ React.createElement(DSModal, {
        className: s['root'],
        isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : false,
        onRequestClose: requestClose,
        contentLabel: t('coreBadge.awardBadgeModal.heading'),
        heading: t('coreBadge.awardBadgeModal.heading'),
        footerLeft: [
            renderWhatAreBadgeAwards()
        ],
        footerRight: [
            renderPrimaryButton()
        ],
        showHeaderBorder: true,
        showFooterBorder: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['content-wrapper']
    }, ' ', /*#__PURE__*/ React.createElement("div", {
        className: s['badges'],
        role: "radiogroup"
    }, badges.map((badge, idx)=>/*#__PURE__*/ React.createElement(BadgeCard, {
            key: badge.badge.name,
            badge: badge,
            selected: idx === selectedIdx,
            showLock: badge.price > balance,
            biData: BiData({
                evid: 322,
                badge_typeid: badge.badge.typeId,
                badge_type: badge.badge.name,
                sectiontype: 'award_badge',
                sectionname: getRecipientSectionName(recipient.typeId),
                typeid: recipient.typeId,
                itemid: recipient.itemId
            }),
            onClick: ()=>changeSelectedBadge(idx)
        }))), showError && /*#__PURE__*/ React.createElement("div", {
        className: s['error']
    }, errorMsg), !showError && selectedIdx !== null && /*#__PURE__*/ React.createElement(React.Fragment, null, hasInsufficientFragmentsForSelectedBadge ? /*#__PURE__*/ React.createElement("div", {
        className: s['need-more']
    }, /*#__PURE__*/ React.createElement(NeedMoreFragments, {
        hasCore: hasCore,
        coreLevel: coreLevel,
        badgeTitle: badges[selectedIdx].badge.title
    })) : /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(BadgeAwardDescription, {
        awardableBadge: badges[selectedIdx],
        user: recipient.user
    }))))));
};
DesktopAwardBadgeModal.displayName = 'DesktopAwardBadgeModal';
export default DesktopAwardBadgeModal;

//# sourceMappingURL=DesktopAwardBadgeModal.js.map